import { TranslatorContext, withIntl } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { DatatableUtil } from '@xengage/gw-portals-util-js';
import classNames from 'classnames';
import { policyCommissionMessages } from 'gw-capability-gateway-commission-react';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { GatewayBillingService } from 'gw-capability-gateway-billing';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import messages from './Billing.messages';
import metadata from './Billing.metadata.json5';
import policyBillingStyles from './Billing.module.scss';

class PolicyBilling extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        authHeader: PropTypes.shape({}).isRequired,
        fromAccountLanding: PropTypes.shape({
            policyDetailsData: PropTypes.shape({
                policyResponse: PropTypes.shape({
                    policyNumber: PropTypes.string,
                    account: PropTypes.shape({
                        accountNumber: PropTypes.string,
                    }),
                }),
            }),
            billingData: PropTypes.shape({}),
        }).isRequired,
        intl: PropTypes.func.isRequired,
        history: PropTypes.shape({
            push: PropTypes.func,
        }).isRequired,
    };

    state = {
        billingData: [],
        currentBillingData: {},
        billingInvoiceData: [],
        paymentHistoryData: [],
        paymentHistoryTotalAmount: {},
        policyPeriodDropDownOptions: [],
        selectedPeriod: '',
        isBillingInfoAvailable: true,
        associationName: {}
    };

    componentDidMount() {
        this.getPolicyBillingSummaryInfo();
        this.loadPaymentHistoryData();
    };
   
    getPolicyBillingSummaryInfo = () => {
        const { fromAccountLanding, authUserData } = this.props;
        const billingInfo = _.get(fromAccountLanding, 'billingData');
        const billingData = _.get(billingInfo, 'policyPeriodBillingSummaries');     

        if (
            !_.isEmpty(billingInfo) &&
            billingData.length > 0 &&
            billingData[0].invoices !== undefined
        ) {
            
            const policyPeriodDropDownOptions = this.getPolicyPeriodDropDownOptions(billingData)
            let currentIndex = policyPeriodDropDownOptions.findIndex((billing) => (billing.name.includes('Current')))
            
            if(currentIndex === -1){
                currentIndex = 0
            }

            const invoiceData = billingData[currentIndex]?.invoices;
            const paymentScheduleDataTable = this.getPaymentScheduleDataTable(invoiceData);

            this.setState({
                billingData,
                billingInvoiceData: paymentScheduleDataTable,
                currentBillingData: billingData[currentIndex],
                policyPeriodDropDownOptions,
                selectedPeriod: billingData[currentIndex].periodNameWithTerm_TWIA,
                associationName: authUserData.associationName_TWIA
            });          
        } else {
            this.setState({ isBillingInfoAvailable: false });
        }
    };

    getPolicyBillingPaymentHistoryTableData = async (policyNumber, authHeaderz) => {
        try {
            await GatewayBillingService.getPaymentSummaryByPolicyNumber(policyNumber, authHeaderz)
            .then((history) =>{
                const tableData = this.getPaymentHistoryDataTable( history?.paymentsHistory);

                this.setState({paymentHistoryData: tableData}) ;
                this.setState({paymentHistoryTotalAmount: history.totalAmount});
           });   
        }
        catch(error){
            // console.log(`there was an error ${  error}`)
        } 
    };

    getPaymentScheduleDataTable = invoiceData => {
        let invoiceArrayResult = [];
        
       const translator = this.context;

        invoiceArrayResult = invoiceData?.map(data => {
            const formattedDueDate = this.getFormattedDate(data.dueDate);
            const formattedBillDate = this.getFormattedDate(data.invoiceDate);
            let paidStatus;    

            if (data.paidStatus.toLowerCase() === 'fully paid' && data.unpaid.amount === 0){
                paidStatus = translator(messages.paidAdjustment);
            } else {
                paidStatus = data.status;
            }

            const objData = {
                dueDate: formattedDueDate,
                billDate: formattedBillDate,
                invoiceNumber: data.invoiceNumber,
                paidStatus,
                status: data.status,
                invoiceTotal: data.amount,
                paid: data.paid,
                outStanding: data.unpaid
            };

            return objData;
        });

        return invoiceArrayResult;
    };

    getPaymentHistoryDataTable = paymentsData => {
        let paymentHistoryArrayResult = [];

        paymentHistoryArrayResult = paymentsData?.map (data => {
            const formattedAppliedDate = _.isUndefined(data.appliedDate)?undefined:this.getFormattedDate(data.appliedDate);
            const formattedReceivedDate = _.isUndefined(data.receivedDate)?undefined:this.getFormattedDate(data.receivedDate);
            const formattedReversedDate = _.isUndefined(data.reversedDate)?undefined:this.getFormattedDate(data.reversedDate);

            const objData = {
                appliedDate: formattedAppliedDate,
                receivedDate: formattedReceivedDate,
                reversedDate: formattedReversedDate,
                refNumber: data.checkReference,
                amount: data.amount,
                paymentMethod: data.paymentMethod
            }

            return objData;
        })

        return paymentHistoryArrayResult;
    }

    loadPaymentHistoryData = () =>{
        // Upload the history

        const { fromAccountLanding, authHeader } = this.props;

        this.getPolicyBillingPaymentHistoryTableData(fromAccountLanding.policyDetailsData.policyResponse.policyNumber, authHeader);
    };

    getBillingStatus = isDelinquent => {
        const translator = this.context;

        if (isDelinquent) {
            return translator(messages.delinquentLabel);
        }

        return translator(messages.inGoodStandingLabel);
    };


    showPastDueAlert = (items) => {
        const today = moment().format('MM/DD/YYYY');
        const dueDate = moment(items.dueDate).format('MM/DD/YYYY');
        
        if (!_.isUndefined(items.dueDate)){
            if ( (moment(today).isAfter(moment(dueDate))) && (items?.outStanding.amount > 0) ) {
                return true;
            }
        }
     
        return false;
    };

    propertyMatch = (property) => property.id === 'paidStatus' || 
                property.id === 'dueDate' || 
                property.id === 'billDate' || 
                property.id === 'invoiceTotal' || 
                property.id === 'outStanding'|| 
                property.id === 'invoiceNumber';


    getCell = (items, index, property) => {
        const translator = this.context;
        const tooltipMessage = {
            dueDate: translator(messages.dueDateLabel),
            paidStatus: translator(messages.paidStatusLabel),
        };
        const showPastDueAlert = this.showPastDueAlert(items);
        const propMatch = this.propertyMatch(property);

        if ( showPastDueAlert && propMatch) {
            // eslint-disable-next-line no-param-reassign
            items.paidStatus = translator(messages.pastDue);
        }

        const classNameShowPastDueAlert = classNames({
            [policyBillingStyles.negativePastDueAlert]: showPastDueAlert,
        });

        return (
            <span title={tooltipMessage[property.id]} className={classNameShowPastDueAlert}>
                {items[property.id]}
            </span>
        );
    };

    getFormattedCurrency = (items, index, property) => {
        const translator = this.context;
        const tooltipMessage = {
            paid: translator(messages.PaidLabel),
            outStanding: translator(messages.outstandingLabel),
            statementAmount: translator(messages.statementAmountLabel),
        };

        const showPastDueAlert = this.showPastDueAlert(items);
        const classNameShowPastDueAlert = classNames({
            [policyBillingStyles.pastDueColorForCurrency]: showPastDueAlert,
        });

        if (showPastDueAlert){
            return (
                <span title={tooltipMessage[property.id]}  >
                    <CurrencyField
                        id={`currency_${index}`}
                        className={classNameShowPastDueAlert}
                        value={items[property.id]}               
                        readOnly
                        hideLabel
                        showOptional={false}
                    />
                </span>
            );
        }

        return (
            <span title={tooltipMessage[property.id]}>
                <CurrencyField
                    id={`currency_${index}`}
                    value={items[property.id]}
                    readOnly
                    hideLabel
                    showOptional={false}
                />
            </span>
        );
    };
 
    getFormattedDate = (val) => {
        const newdate = moment(val).toDate();

        return moment(newdate).format('MM/DD/YYYY');
            
    };

    getPolicyPeriodDropDownOptions = billingData => {
        const translator = this.context;

        if (_.isEmpty(billingData)) {
            return null;
        }

        const now = moment();
        const { fromAccountLanding } = this.props;
        const { latestPeriod } = fromAccountLanding.policyDetailsData.policyResponse;

        return billingData.map((key) => {
            let policyPeriodName = `${key.periodNameWithTerm_TWIA}`;

            if ( key.effectiveDate && now.isAfter(key.effectiveDate) 
                &&  key.expirationDate && now.isBefore(key.expirationDate)
            ) {
                if (latestPeriod.term_TWIA === key.termNumber_TWIA){
                    policyPeriodName = `${policyPeriodName} ${translator( policyCommissionMessages.current )}`
                } else {
                    policyPeriodName = `${policyPeriodName}`;
                }             
            }

            return {
                code: key.periodNameWithTerm_TWIA,
                name: policyPeriodName,
            };
        });
    };

    handlePolicyPeriodChange = policyPeriod => {
        const { billingData } = this.state;
        const policyChangeData = billingData.find( data => data.periodNameWithTerm_TWIA === policyPeriod );
        const invoiceData = policyChangeData.invoices;
        const paymentScheduleDataTable = this.getPaymentScheduleDataTable(invoiceData);

        this.setState({
            billingInvoiceData: paymentScheduleDataTable,
            currentBillingData: policyChangeData,
            selectedPeriod: policyPeriod,
        });
        // load Payment History Data
        this.loadPaymentHistoryData();
    };

    getPolicyStatusIcon = billingData => {
        if (billingData.isDelinquent) {
            return 'mi-warning';
        }

        return 'mi-check';
    };

    getPolicyStatusClassname = billingData => classNames(policyBillingStyles.policyBillingIcon, {
            [policyBillingStyles.policyBillingDelinquent]:
                billingData.isDelinquent,
            [policyBillingStyles.policyBillingGoodStanding]:
                !billingData.isDelinquent,
        });

    handleViewAccountBilling = () => {
        const {
            history,
            fromAccountLanding: {
                policyDetailsData: { policyResponse },
            },
        } = this.props;
        const {
            account: { accountNumber },
        } = policyResponse;
        const nextPath = `/accounts/${accountNumber}/billingAndPayment`;
        
        history.push({
            pathname: nextPath,
            accountDetailsData: { accountNumber },
        });
    };

    render() {
        const {
            billingInvoiceData,
            paymentHistoryData,
            paymentHistoryTotalAmount,
            currentBillingData,
            policyPeriodDropDownOptions,
            selectedPeriod,
            isBillingInfoAvailable,
            associationName
        } = this.state;
      
        const translator = this.context;

        const showPastDueLine = currentBillingData.aggregatedPastDueAmount && currentBillingData.aggregatedPastDueAmount.amount > 0;
        const showCurrentPaymentLine = currentBillingData.nextDueAmount && currentBillingData.nextDueAmount.amount > 0;

        const overrides = {
            billingPagePolicyStatusIcon: {
                icon: this.getPolicyStatusIcon(currentBillingData),
                className: this.getPolicyStatusClassname(currentBillingData),
            },
            tabBillingSummaryTotalPremium: {
                value: currentBillingData.totalPremium,
            },
            billingPageAutoPayEnabled: {
                visible: associationName === 'twia',
                value: currentBillingData.isAutoDraft_TWIA?"YES":"NO",
            },
            tabBillingSummaryTaxesAndFees: {
                value: currentBillingData.taxesAndFees,
            },
            billingPagePaymentPlan: {
                value: currentBillingData.paymentPlan,
            },
            tabBillingSummaryTotalCosts: {
                value: currentBillingData.totalCost,
            },
            billingPagePolicyBillingStatus: {
                value: this.getBillingStatus(currentBillingData.isDelinquent),
            },
            tabBillingSummaryPastDueContainer: {
                visible: showPastDueLine,
            },
            tabBillingSummaryPastDue: {
                value: currentBillingData.aggregatedPastDueAmount,
            },
            tabBillingSummaryPastDueDate: {
                content: this.getFormattedDate(currentBillingData.pastDueDate),
            },
            tabBillingSummaryNextPaymentContainer: {
                visible: showCurrentPaymentLine,
            },
            tabBillingSummaryNextPayment: {
                value: currentBillingData.nextDueAmount,
            },
            billingSummaryNextDueDate: {
                content: this.getFormattedDate(currentBillingData.nextDueDate),
            },
            tabBillingSummaryTotalDue: {
                value: currentBillingData.totalDueAmount,
            },
            tabBillingSummaryBillingMethod: {
                value: translator({
                    id: `typekey.BillingMethod.${currentBillingData.billingMethod}`,
                    defaultMessage: `typekey.BillingMethod.${currentBillingData.billingMethod}`,
                }),
            },
            tabBillingSummaryPaymentPlan: {
                value: currentBillingData.paymentPlan,
            },
            paymentScheduledTable: {
                data: billingInvoiceData,
            },
            paymentHistoryTable: {
                    data: paymentHistoryData,
            },
            policyPeriodDropDown: {
                availableValues: policyPeriodDropDownOptions,
                value: selectedPeriod,
            },
            billingInfoContainer: {
                visible: isBillingInfoAvailable,
            },
            billingEmptyContainer: {
                visible: !isBillingInfoAvailable,
            },
            warningMessage: {
                value: translator(messages.noBillingDataLabel),
            },
            totalPaymentHistoryAmount: {
                value: paymentHistoryTotalAmount
            }
        };
        const resolvers = {
            resolveClassNameMap: policyBillingStyles,
            resolveCallbackMap: {
                getCell: this.getCell,
                getFormattedCurrency: this.getFormattedCurrency,
                handlePolicyPeriodChange: this.handlePolicyPeriodChange,
                handleViewAccountBilling: this.handleViewAccountBilling,
                sortDate: DatatableUtil.sortDate,
                sortString: DatatableUtil.sortString,
                sortCurrency: DatatableUtil.sortCurrency,
            },
        };

        const policyPage = (
            <MetadataContent
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                {...resolvers}
            />
        );

        return (
            <div className={policyBillingStyles.policybilling}>
                {policyPage}
            </div>
        );
    }
}

export const BillingComponent = PolicyBilling;
export default withIntl(withAuthenticationContext(PolicyBilling));
